//export var endpoint = 'https://localhost:7170'
//export var endpoint = 'https://localhost:44304';
// Prod endpoints
export var endpoint = 'https://skillsynchrony.com:5000';